"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3137],{

/***/ 3735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tz": function() { return /* binding */ AutoColumn; },
/* harmony export */   "lg": function() { return /* binding */ ColumnCenter; },
/* harmony export */   "sg": function() { return /* binding */ Column; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30696);




var Column = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_ui__WEBPACK_IMPORTED_MODULE_1__/* .AtomBox */ .p, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
    }, props));
};
var AutoColumn = function(_param) /*#__PURE__*/ {
    var gap = _param.gap, justify = _param.justify, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "gap",
        "justify"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_ui__WEBPACK_IMPORTED_MODULE_1__/* .AtomBox */ .p, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "grid",
        gridAutoRows: "auto",
        justifyItems: justify,
        rowGap: gap
    }, props));
};
var ColumnCenter = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "full",
        alignItems: "center"
    }, props));
};


/***/ }),

/***/ 72963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ QuestionHelper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98813);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13670);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78933);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :hover,\n  :focus {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-35be06be-0"
})(_templateObject());
var QuestionHelper = function(_param) {
    var text = _param.text, _placement = _param.placement, placement = _placement === void 0 ? "right-end" : _placement, _size = _param.size, size = _size === void 0 ? "16px" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "placement",
        "size"
    ]);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(text, {
        placement: placement
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionWrapper, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: "textSubtle",
                    width: size
                })
            })
        ]
    }));
};


/***/ }),

/***/ 92372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30696);




var Row = function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? "100%" : _width, _alignItems = _param.alignItems, alignItems = _alignItems === void 0 ? "center" : _alignItems, _justifyContent = _param.justifyContent, justifyContent = _justifyContent === void 0 ? "flex-start" : _justifyContent, _padding = _param.padding, padding = _padding === void 0 ? "0" : _padding, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "alignItems",
        "justifyContent",
        "padding"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_ui__WEBPACK_IMPORTED_MODULE_2__/* .AtomBox */ .p, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        display: "flex",
        width: width,
        alignItems: alignItems,
        justifyContent: justifyContent,
        padding: padding
    }, props));
};
var AutoRow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        flexWrap: "wrap"
    }, props));
};
var RowFixed = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "fit",
        flexWrap: "wrap"
    }, props));
};
var RowBetween = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        flexWrap: "wrap",
        justifyContent: "space-between"
    }, props));
};


/***/ }),

/***/ 10669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16zM8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35a.501.501 0 00-.7 0z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 83611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 96 96"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "48",
                cy: "48",
                r: "48",
                fill: "#F0B90B"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30.9008 25.9057L47.8088 16.0637L64.7169 25.9057L58.5007 29.5416L47.8088 23.3355L37.117 29.5416L30.9008 25.9057ZM64.7169 38.3179L58.5007 34.682L47.8088 40.8881L37.117 34.682L30.9008 38.3179V45.5897L41.5926 51.7958V64.2079L47.8088 67.8438L54.0251 64.2079V51.7958L64.7169 45.5897V38.3179ZM64.7169 58.0018V50.7301L58.5007 54.366V61.6377L64.7169 58.0018ZM69.1305 60.572L58.4386 66.7781V74.0499L75.3467 64.2079V44.524L69.1305 48.1599V60.572ZM62.9143 32.1118L69.1305 35.7477V43.0195L75.3467 39.3836V32.1118L69.1305 28.4759L62.9143 32.1118ZM41.5926 69.411V76.6828L47.8088 80.3187L54.0251 76.6828V69.411L47.8088 73.0469L41.5926 69.411ZM30.9008 58.0018L37.117 61.6377V54.366L30.9008 50.7301V58.0018ZM41.5926 32.1118L47.8088 35.7477L54.0251 32.1118L47.8088 28.4759L41.5926 32.1118ZM26.4872 35.7477L32.7034 32.1118L26.4872 28.4759L20.271 32.1118V39.3836L26.4872 43.0195V35.7477ZM26.4872 48.1599L20.271 44.524V64.2079L37.1791 74.0499V66.7781L26.4872 60.572V48.1599Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 46178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.97 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99996C9.74996 2 9.53996 2.18 9.50996 2.42L9.12996 5.07C8.51996 5.32 7.95996 5.66 7.43996 6.05L4.94996 5.05C4.71996 4.96 4.45996 5.05 4.33996 5.27L2.33996 8.73C2.20996 8.95 2.26996 9.22 2.45996 9.37L4.56996 11.02C4.52996 11.34 4.49996 11.67 4.49996 12C4.49996 12.33 4.52996 12.66 4.56996 12.98L2.45996 14.63C2.26996 14.78 2.21996 15.05 2.33996 15.27L4.33996 18.73C4.45996 18.95 4.72996 19.03 4.94996 18.95L7.43996 17.95C7.95996 18.35 8.51996 18.68 9.12996 18.93L9.50996 21.58C9.53996 21.82 9.74996 22 9.99996 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.28 19.04 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM12 15.5C10.07 15.5 8.49996 13.93 8.49996 12C8.49996 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 35:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13 3C8.03 3 4 7.03 4 12H2.20711C1.76165 12 1.53857 12.5386 1.85355 12.8536L4.54604 15.546C4.73751 15.7375 5.04662 15.7418 5.24329 15.5556L8.08805 12.8631C8.4164 12.5524 8.19646 12 7.74435 12H6C6 8.13 9.13 5 13 5C16.87 5 20 8.13 20 12C20 15.87 16.87 19 13 19C11.4314 19 9.98175 18.4782 8.81739 17.601C8.37411 17.267 7.74104 17.259 7.3486 17.6514C6.95725 18.0428 6.95413 18.6823 7.38598 19.0284C8.92448 20.2615 10.8708 21 13 21C17.97 21 22 16.97 22 12C22 7.03 17.97 3 13 3ZM12 8V13L16.28 15.54L17 14.33L13.5 12.25V8H12Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 39625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Swap; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(93058);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(52180);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowUpDown.tsx
var ArrowUpDown = __webpack_require__(10669);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Swap/SwapWidget.css.ts
var SwapWidget_css = __webpack_require__(15578);
// EXTERNAL MODULE: ../../packages/ui/components/AtomBox.tsx + 7 modules
var AtomBox = __webpack_require__(30696);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Swap/NumericalInput.tsx + 1 modules
var NumericalInput = __webpack_require__(38934);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/CurrencyInputPanel.tsx




function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, zapStyle = param.zapStyle, top = param.top, bottom = param.bottom, id = param.id, disabled = param.disabled, error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: top
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                position: "relative",
                backgroundColor: "backgroundAlt",
                zIndex: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
                        as: "label",
                        className: (0,SwapWidget_css/* inputContainerVariants */.U7)({
                            hasZapStyle: !!zapStyle,
                            error: error
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                color: "text",
                                fontSize: "12px",
                                lineHeight: "16px",
                                px: "16px",
                                pt: "12px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericalInput/* NumericalInput */.$, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            bottom
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                        role: "presentation",
                        position: "absolute",
                        inset: "0",
                        backgroundColor: "backgroundAlt",
                        opacity: "0.6"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(48497);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(89495);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/CurrencyInputHeader.tsx




var CurrencyInputHeader = function(param) {
    var title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
        width: "full",
        alignItems: "center",
        flexDirection: "column",
        padding: "24px",
        borderBottom: "1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: "flex",
                width: "full",
                alignItems: "center",
                justifyContent: "space-between",
                children: title
            }),
            subtitle
        ]
    });
};
var CurrencyInputHeaderTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        as: "h2",
        children: children
    });
};
var CurrencyInputHeaderSubTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        textAlign: "center",
        children: children
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/Page.tsx






var SwapPage = function(_param) /*#__PURE__*/ {
    var removePadding = _param.removePadding, noMinHeight = _param.noMinHeight, children = _param.children, hideFooterOnDesktop = _param.hideFooterOnDesktop, helpUrl = _param.helpUrl, isEvm = _param.isEvm, helpImage = _param.helpImage, props = (0,_object_without_properties/* default */.Z)(_param, [
        "removePadding",
        "noMinHeight",
        "children",
        "hideFooterOnDesktop",
        "helpUrl",
        "isEvm",
        "helpImage"
    ]);
    return (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,SwapWidget_css/* pageVariants */.wz)({
            removePadding: removePadding,
            noMinHeight: noMinHeight
        })
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: "flex",
                flexGrow: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: [
                    "block",
                    null,
                    null,
                    hideFooterOnDesktop ? "none" : "block"
                ],
                width: "100%",
                height: "64px"
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var src = __webpack_require__(65957);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(76903);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(96469);
// EXTERNAL MODULE: ../../packages/uikit/src/components/ButtonMenu/ButtonMenu.tsx
var ButtonMenu = __webpack_require__(2448);
// EXTERNAL MODULE: ../../packages/uikit/src/components/ButtonMenu/ButtonMenuItem.tsx
var ButtonMenuItem = __webpack_require__(97984);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(35378);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(48608);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(62923);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/Footer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-top: 16px;\n  padding-right: ",
        ";\n  ",
        " {\n    justify-content: space-between;\n    flex-direction: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    fill: ",
        ";\n    transition: background-color 0.2s, opacity 0.2s;\n  }\n  &:hover {\n    svg {\n      opacity: 0.65;\n    }\n  }\n  &:active {\n    svg {\n      opacity: 0.85;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-535f6cfd-0"
})(_templateObject(), function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "100%" : "auto";
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "32px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "column" : "row";
});
var BubbleWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-535f6cfd-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var Footer = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, helpUrl = param.helpUrl, _helpImage = param.helpImage, helpImage = _helpImage === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "https://cdn.pancakeswap.com/help/help.png",
        alt: "Get some help",
        width: 160,
        height: 108
    }) : _helpImage, _isEvm = param.isEvm, isEvm = _isEvm === void 0 ? true : _isEvm;
    var t = (0,src/* useTranslation */.$G)().t;
    var isSide = variant === "side";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        $isSide: isSide,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexDirection: isSide ? "column" : [
                    "column",
                    "column",
                    "row"
                ],
                alignItems: "center",
                children: isEvm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonMenu/* default */.Z, {
                            variant: "subtle",
                            scale: "sm",
                            activeIndex: 0,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                    children: "V2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonMenuItem/* default */.Z, {
                                    as: "a",
                                    href: "https://v1exchange.pancakeswap.finance/#/",
                                    children: t("V1 (old)")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                            id: "ercBridge",
                            href: "https://docs.binance.org/smart-chain/guides/cross-chain.html",
                            ml: [
                                0,
                                0,
                                "40px"
                            ],
                            mt: [
                                "20px",
                                "20px",
                                isSide ? "20px" : 0
                            ],
                            mb: [
                                "8px",
                                "8px",
                                0
                            ],
                            children: t("Convert ERC-20 to BEP-20")
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            }),
            isSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexGrow: 1
            }),
            helpUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexGrow: isSide ? 0 : 1,
                alignItems: "center",
                width: [
                    "100%",
                    "100%",
                    "100%",
                    isSide ? "100%" : "auto"
                ],
                justifyContent: [
                    "center",
                    "center",
                    "center",
                    "flex-end"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BubbleWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                id: "clickExchangeHelp",
                                as: "a",
                                external: true,
                                href: helpUrl,
                                variant: "subtle",
                                children: t("Need help ?")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, {
                                viewBox: "0 0 16 16",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M0 16V0C0 0 3 1 6 1C9 1 16 -2 16 3.5C16 10.5 7.5 16 0 16Z"
                                })
                            })
                        ]
                    }),
                    helpImage
                ]
            })
        ]
    });
};
var SwapFooter = /*#__PURE__*/ (0,react.memo)(Footer);

// EXTERNAL MODULE: ../../packages/hooks/src/index.ts + 10 modules
var hooks_src = __webpack_require__(39655);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Column/index.tsx
var Column = __webpack_require__(3735);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Row/Row.tsx
var Row = __webpack_require__(92372);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/SwapInfo.tsx





var SwapInfoLabel = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, (0,_object_spread/* default */.Z)({
        fontSize: "12px",
        bold: true,
        color: "secondary"
    }, props));
};
var SwapInfo = function(param) {
    var allowedSlippage = param.allowedSlippage, price = param.price;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMounted = (0,hooks_src/* useIsMounted */.tm)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "sm",
        py: "0",
        px: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                alignItems: "center",
                children: price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapInfoLabel, {
                        children: t("Slippage Tolerance")
                    }),
                    isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        color: "primary",
                        children: [
                            allowedSlippage / 100,
                            "%"
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(73685);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/TradePrice.tsx





function TradePrice(param) {
    var price = param.price;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), showInverted = ref5[0], setShowInverted = ref5[1];
    var formattedPrice = showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(6) : (ref = price === null || price === void 0 ? void 0 : price.invert()) === null || ref === void 0 ? void 0 : ref.toSignificant(6);
    var show = Boolean((price === null || price === void 0 ? void 0 : price.baseCurrency) && (price === null || price === void 0 ? void 0 : price.quoteCurrency));
    var label = showInverted ? "".concat(price === null || price === void 0 ? void 0 : (ref1 = price.quoteCurrency) === null || ref1 === void 0 ? void 0 : ref1.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref2 = price.baseCurrency) === null || ref2 === void 0 ? void 0 : ref2.symbol) : "".concat(price === null || price === void 0 ? void 0 : (ref3 = price.baseCurrency) === null || ref3 === void 0 ? void 0 : ref3.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref4 = price.quoteCurrency) === null || ref4 === void 0 ? void 0 : ref4.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: {
            justifyContent: "center",
            alignItems: "center",
            display: "flex"
        },
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "-",
                " ",
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                    className: SwapWidget_css/* balanceMaxMiniClass */.y2,
                    onClick: function() {
                        return setShowInverted(!showInverted);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        width: "14px"
                    })
                })
            ]
        }) : "-"
    });
}

;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/SwapWidget.tsx












var SwapSwitchButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: SwapWidget_css/* switchButtonClass */.ZQ,
        variant: "light",
        scale: "sm"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                className: SwapWidget_css/* iconDownClass */.VO,
                color: "primary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpDown/* default */.Z, {
                className: SwapWidget_css/* iconUpDownClass */.AG,
                color: "primary"
            })
        ]
    }));
};
var Swap = {
    SwitchButton: SwapSwitchButton,
    CurrencyInputHeaderTitle: CurrencyInputHeaderTitle,
    CurrencyInputHeaderSubTitle: CurrencyInputHeaderSubTitle,
    CurrencyInputHeader: CurrencyInputHeader,
    CurrencyInputPanel: CurrencyInputPanel,
    Page: SwapPage,
    Footer: SwapFooter,
    Info: SwapInfo,
    InfoLabel: SwapInfoLabel,
    TradePrice: TradePrice
};



/***/ })

}]);